export default __webpack_public_path__ + "static/cimode-4388dfb01646ff8dc71da3b120d30ab5.svg";